import { render, staticRenderFns } from "./sanxiangbupingheng.vue?vue&type=template&id=3cc6f08b&scoped=true&"
import script from "./sanxiangbupingheng.vue?vue&type=script&lang=js&"
export * from "./sanxiangbupingheng.vue?vue&type=script&lang=js&"
import style0 from "./sanxiangbupingheng.vue?vue&type=style&index=0&id=3cc6f08b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc6f08b",
  null
  
)

export default component.exports